/* eslint-disable no-restricted-syntax -- this line was auto generated, hence fix the issue timely */
import React, { useMemo } from "react";
import { useViewport } from "@bookingcom/bui-react";
import { Sidebar } from "../../Container";
import SearchTabs from "../../SearchTabs";
import { SkeletonFlightCard } from "../SkeletonFlightCard";
import { SkeletonListKeyValue } from "../SkeletonListKeyValue";
import { SearchLoadingMessage } from "../../SearchLoadingMessage";
import Frame from "../../Frame";
import useRouteName from "../../../../hooks/useRouteName";
import { trackWithDefaultStage } from "@flights/et-universal";
import styles from "./SkeletonSearchDesktop.module.css";
import { useSplitBoundsCondition } from "../../../../utils/experiments/funnel/flights_split_bounds_us";
import flights_web_remove_fastest_sorting from "../../../../utils/experiments/funnel/flights_web_remove_fastest_sorting";

interface Props {
  text?: string;
}

export const SkeletonSearchContent = ({ count = 4 }: { count?: number }) => {
  return (
    <React.Fragment>
      <SearchLoadingMessage />
      {Array.from({ length: count }).map((_, i) => (
        <Frame key={i} mt={3} mb={3}>
          <SkeletonFlightCard />
        </Frame>
      ))}
    </React.Fragment>
  );
};

const SkeletonSearchDesktop: React.FunctionComponent<Props> = () => {
  const routeName = useRouteName();
  const { isLarge } = useViewport();

  const isResponsiveFixes = !isLarge && !!trackWithDefaultStage("flights_web_cat_responsive_fixes_www", 1);

  const className = useMemo(() => (routeName.includes("flightdetails") ? styles.blur : ""), [routeName]);
  const { isSplitBounds } = useSplitBoundsCondition();

  const removeFastestSorting = !!flights_web_remove_fastest_sorting.trackWithDefaultStage();

  return (
    <Frame direction="row" className={className}>
      {/* START: Left Column */}
      {!isResponsiveFixes ? (
        <Sidebar>
          <Frame p={4}>
            <SkeletonListKeyValue amount={12} />
          </Frame>
        </Sidebar>
      ) : null}
      {/* END: Left Column */}

      {/* START: Right Column */}
      <Frame grow={1} pb={0} pl={isResponsiveFixes ? 0 : 6}>
        {isSplitBounds || removeFastestSorting ? undefined : <SearchTabs showBestRankingInfo fill />}
        <SkeletonSearchContent />
      </Frame>
      {/* END: Right Column */}
    </Frame>
  );
};

export default SkeletonSearchDesktop;
